
const sortByLabel = (a,b) => {
    let x = a.label
    let y = b.label
    return x>y ? 1 :
        x<y ? -1 : 0
}
const mapLabel = (a) => {
    a.label = a.display
    return a
}

export const STATES = [
    {display:'Alabama', value:'AL'},
    {display:'Alaska', value:'AK'},
    {display:'Arizona', value:'AZ'},
    {display:'Arkansas', value:'AR'},
    {display:'California', value:'CA'},
    {display:'Colorado', value:'CO'},
    {display:'Connecticut', value:'CT'},
    {display:'Delaware', value:'DE'},
    {display:'Dist of Columbia', value:'DC'},
    {display:'Florida', value:'FL'},
    {display:'Georgia', value:'GA'},
    {display:'Hawaii', value:'HI'},
    {display:'Idaho', value:'ID'},
    {display:'Illinois', value:'IL'},
    {display:'Indiana', value:'IN'},
    {display:'Iowa', value:'IA'},
    {display:'Kansas', value:'KS'},
    {display:'Kentucky', value:'KY'},
    {display:'Louisiana', value:'LA'},
    {display:'Maine', value:'ME'},
    {display:'Maryland', value:'MD'},
    {display:'Massachusetts', value:'MA'},
    {display:'Michigan', value:'MI'},
    {display:'Minnesota', value:'MN'},
    {display:'Mississippi', value:'MS'},
    {display:'Missouri', value:'MO'},
    {display:'Montana', value:'MT'},
    {display:'Nebraska', value:'NE'},
    {display:'Nevada', value:'NV'},
    {display:'New Hampshire', value:'NH'},
    {display:'New Jersey', value:'NJ'},
    {display:'New Mexico', value:'NM'},
    {display:'New York', value:'NY'},
    {display:'North Carolina', value:'NC'},
    {display:'North Dakota', value:'ND'},
    {display:'Ohio', value:'OH'},
    {display:'Oklahoma', value:'OK'},
    {display:'Oregon', value:'OR'},
    {display:'Pennsylvania', value:'PA'},
    {display:'Rhode Island', value:'RI'},
    {display:'South Carolina', value:'SC'},
    {display:'South Dakota', value:'SD'},
    {display:'Tennessee', value:'TN'},
    {display:'Texas', value:'TX'},
    {display:'Utah', value:'UT'},
    {display:'Vermont', value:'VT'},
    {display:'Virginia', value:'VA'},
    {display:'Washington', value:'WA'},
    {display:'West Virginia', value:'WV'},
    {display:'Wisconsin', value:'WI'},
    {display:'Wyoming', value:'WY'}
].map(mapLabel).sort(sortByLabel)

export const TERRITORIES = [
    {display:'American Samoa', value:'AS'},
    {display:'Guam', value:'GU'},
    {display:'Puerto Rico', value:'PR'},
    {display:'Virgin Islands', value:'VI'},
].map(mapLabel).sort(sortByLabel)

export const STATES_AND_TERRITORIES = STATES
    .concat(TERRITORIES)
    .sort(sortByLabel)


export const STATE_NAMES = STATES_AND_TERRITORIES
    .reduce( (x, a) => ({...x, ...{[a.value]: a.label}}), {})


const mapCD = (a) => {
    return {
        ...a,
        value: 'holdBlueSkyStateCD=' + encodeURIComponent(a.value)
    }
}
export const CD_STATES = STATES.map(mapCD)
export const CD_TERRITORIES = TERRITORIES.map(mapCD)
export const CD_STATES_AND_TERRITORIES = STATES_AND_TERRITORIES.map(mapCD)


const mapMuni = (a) => {
    return {
        ...a,
        value: 'holdState=' + encodeURIComponent(a.value)
    }
}
export const MUNI_STATES = STATES.map(mapMuni)
export const MUNI_TERRITORIES = TERRITORIES.map(mapMuni)
export const MUNI_STATES_AND_TERRITORIES = STATES_AND_TERRITORIES.map(mapMuni)



